import React from 'react';
import { Link } from 'react-router-dom';
import { MetadataFieldNames } from '~/types/common';
const DocumentTitleCell = (props) => {
    var _a, _b, _c, _d;
    if (!props.colDef)
        return;
    const isCollapsed = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.isCollapsed) !== null && _b !== void 0 ? _b : false;
    const columnName = props.colDef.field;
    const documents = (_d = (_c = props.data) === null || _c === void 0 ? void 0 : _c.documents.map((metadata) => {
        var _a, _b;
        const fileName = (_a = metadata.find(m => m.name === columnName)) === null || _a === void 0 ? void 0 : _a.value;
        const fileId = (_b = metadata.find(m => m.name === MetadataFieldNames.fileid)) === null || _b === void 0 ? void 0 : _b.value;
        return {
            fileName: typeof fileName === 'string' ? fileName : '',
            fileId: typeof fileId === 'string' ? fileId : '',
        };
    })) !== null && _d !== void 0 ? _d : [];
    return (documents === null || documents === void 0 ? void 0 : documents.map((doc, index) => (React.createElement(Link, { title: doc.fileName, target: '_blank', to: {
            pathname: `/document/${doc.fileId}`,
        } },
        doc.fileName,
        isCollapsed && documents.length !== (index + 1) && ', ',
        !isCollapsed && (React.createElement("br", null))))));
};
export default DocumentTitleCell;
